module.exports = __webpack_public_path__ + "static/media/Functions-banner.2e8087b5.jpg";